module.exports = __webpack_public_path__ + "static/models/ticker_left.247b260.json";


//////////////////
// WEBPACK FOOTER
// ./src/assets/models/track/models/ticker_left.json
// module id = 547
// module chunks = 1